module.exports = __webpack_public_path__ + "static/img/sub_page_banner_7.fd60a3b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sub_page_banner_7.jpg
// module id = nRof
// module chunks = 0